module.exports = __webpack_public_path__ + "static/aave-ee6fd8e2e147ebc5760675128e83873c.png";